export const formatModuleName = (name) => {
  if (!name) return '';
  const lower = name.toLowerCase();
  if (
    lower === 'lead_all' ||
    lower === 'leads_all' ||
    lower === 'crm_leads_all' ||
    lower === 'crm leads (all)' ||
    lower === 'crm leads all'
  )
    return 'CRM Leads (All)';
  if (
    lower === 'lead_management' ||
    lower === 'lead_details' ||
    lower === 'lead details' ||
    lower === 'crm leads management'
  )
    return 'CRM Leads Management';
  if (lower === 'pipelines' || lower === 'pipeline') return 'Inquiries';
  if (lower === 'segments' || lower === 'segment') return 'Groups';
  if (lower === 'lead' || lower === 'leads' || lower === 'crm leads')
    return 'CRM Leads';
  if (lower === 'crm_config' || lower === 'crm config')
    return 'CRM Configuration';
  if (
    lower === 'auto_assignment' ||
    lower === 'auto assignment' ||
    lower === 'smart_assignment'
  )
    return 'Auto Assignment';
  if (lower === 'custom_fields' || lower === 'custom fields')
    return 'Custom Fields';
  if (lower === 'tags' || lower === 'tag') return 'Tags';
  if (lower === 'quotation' || lower === 'quotations') return 'Quotations';
  if (lower === 'reminder' || lower === 'reminders') return 'Reminders';
  return name.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
};

export const MODULE_SORT_ORDER = [
  'CRM Leads',
  'CRM Leads (All)',
  'CRM Leads Management',
  'Inquiries',
  'Groups',
  'Reminders',
  'Appointments',
  'CRM Configuration',
  'Auto Assignment',
  'Custom Fields',
  'Tags',
  'Quotations',
  'Profile',
  'Business Card',
  'Integrations',
];

export const groupPermissions = (permsData, search = '') => {
  if (!permsData) return [];

  const searchLower = search.toLowerCase();
  const groupsMap = {};

  const processPerm = (perm, explicitModule = null) => {
    const lowerKey = (perm.key || perm.codename || '').toLowerCase();
    const isLeadAll =
      lowerKey === 'lead.view_all' ||
      lowerKey === 'lead.create_all' ||
      lowerKey === 'lead.update_all' ||
      lowerKey === 'lead.delete_all' ||
      lowerKey.endsWith('_all');

    let moduleName = explicitModule;
    if (isLeadAll) {
      moduleName = 'CRM Leads (All)';
    } else if (!moduleName) {
      const parts = (perm.name || '').split(' ');
      moduleName = parts.length > 1 ? parts.slice(1).join(' ') : parts[0];
    }

    if (searchLower) {
      const modMatches = moduleName.toLowerCase().includes(searchLower);
      const nameMatches = (perm.name || '').toLowerCase().includes(searchLower);
      const codeMatches = lowerKey.includes(searchLower);
      if (!modMatches && !nameMatches && !codeMatches) return;
    }

    const parts = (perm.name || '').split(' ');
    const actionFromName = parts[0].toLowerCase();
    const slug = moduleName.toLowerCase().replace(/[^a-z0-9]+/g, '-');

    if (!groupsMap[moduleName]) {
      groupsMap[moduleName] = {
        name: moduleName,
        slug,
        actions: { read: null, add: null, edit: null, delete: null },
      };
    }

    const lowerAction = lowerKey.split('.').pop();

    let action = 'read';
    if (
      ['view', 'read', 'list', 'get', 'show', 'view_all'].includes(
        lowerAction,
      ) ||
      ['view', 'read'].includes(actionFromName)
    )
      action = 'read';
    else if (
      ['create', 'add', 'insert', 'make', 'send', 'create_all'].includes(
        lowerAction,
      ) ||
      ['create', 'add', 'send'].includes(actionFromName)
    )
      action = 'add';
    else if (
      [
        'update',
        'edit',
        'manage',
        'configure',
        'modify',
        'update_all',
      ].includes(lowerAction) ||
      ['edit', 'update'].includes(actionFromName)
    )
      action = 'edit';
    else if (
      ['delete', 'remove', 'destroy', 'archive', 'delete_all'].includes(
        lowerAction,
      ) ||
      ['delete', 'remove'].includes(actionFromName)
    )
      action = 'delete';

    if (!groupsMap[moduleName].actions[action]) {
      groupsMap[moduleName].actions[action] = perm;
    } else {
      if (!groupsMap[moduleName].actions.read)
        groupsMap[moduleName].actions.read = perm;
      else if (!groupsMap[moduleName].actions.edit)
        groupsMap[moduleName].actions.edit = perm;
      else if (!groupsMap[moduleName].actions.add)
        groupsMap[moduleName].actions.add = perm;
      else if (!groupsMap[moduleName].actions.delete)
        groupsMap[moduleName].actions.delete = perm;
    }
  };

  if (Array.isArray(permsData)) {
    permsData.forEach((p) => processPerm(p));
  } else if (typeof permsData === 'object') {
    if (permsData.results && Array.isArray(permsData.results)) {
      permsData.results.forEach((p) => processPerm(p));
    } else {
      Object.entries(permsData).forEach(([moduleName, perms]) => {
        if (Array.isArray(perms)) {
          perms.forEach((p) => processPerm(p, moduleName));
        }
      });
    }
  }

  const groups = Object.values(groupsMap);
  return groups.sort((a, b) => {
    const nameA = formatModuleName(a.name);
    const nameB = formatModuleName(b.name);
    const indexA = MODULE_SORT_ORDER.indexOf(nameA);
    const indexB = MODULE_SORT_ORDER.indexOf(nameB);
    const orderA = indexA === -1 ? 999 : indexA;
    const orderB = indexB === -1 ? 999 : indexB;
    if (orderA !== orderB) return orderA - orderB;
    return nameA.localeCompare(nameB);
  });
};
